export const DIMENSION_ID_PREFIX = 'd';
export const DIMENSIONS_FORM_STATE_KEY = 'dimensions';
export const DIMENSION_VALUES_FORM_STATE_KEY = 'dimensionValueKey';
export const NO_DIMENSION_KEY = 0;
